import { useState } from "react";
import { toast } from "react-toastify";
import Spinner from "../../components/Spinner";
import { Link } from "react-router-dom";
import SidePanel from "../../components/SidePanel";

const ResetPassword = () => {
  const [loader, setLoader] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const token = localStorage.getItem("token");

  const handleChange = async (e) => {
    e.preventDefault();
    // const queryParameters = new URLSearchParams(window.location.search);
    // const token = queryParameters.get("token");
    setLoader(true);
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/auth/change-password`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
        body: JSON.stringify({
          currentPassword: currentPassword,
          newPassword,
          confirmPassword: confirmNewPassword,
        }),
      }
    );
    const data = await res.json();
    const status = data.code;
    setLoader(false);
    if (status === 200) {
      toast.success("Password Changed Successfully");
      window.location.href = "/dashboard/profile";
    } else {
      toast.error(data.message);
    }
  };

  // <div className="flex flex-col w-full md:p-3 py-3">
  //               <div className="flex md:items-start justify-between w-full md:mb-5 mt-5">
  //                   <div className="md:w-[80%] w-full">
  //                   <div className="flex flex-col w-full text-2xl">
  //                       <label className="text-sm text-gray-400">Name</label>
  //                       <input
  //                       type="text"
  //                       name="fullName"
  //                       value={profile.fullName || ""}
  //                       onChange={handleInputChange} // You might need a new handler to update the recipients state
  //                       className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 placeholder:text-gray-300 w-full"
  //                       />
  //                   </div>

  return (
    <section className="flex mx-auto lg:pl-[20%] mt-16 px-8 sm:px-2 py-5 text-xl">
      <SidePanel />
      <div className="w-full">
        <h3 className="mb-5 mt-4">
          <Link to="/dashboard/profile" className="hover:underline">
            User Profile
          </Link>
          {" >"} <span className="text-primary">Change Password</span>
        </h3>
        <div className="space-y-10">
          <div className="p-10 bg-[#F1F1F1] rounded-md ">
            <div className="flex flex-col items-center justify-center my-10">
              <h1 className="font-semibold text-3xl mb-10">Change Password</h1>
              <form className="w-full max-w-xl" onSubmit={handleChange}>
                <div className="flex flex-col mb-6">
                  <label htmlFor="currentPassword" className="text-lg mb-2">
                    Current Password
                  </label>
                  <input
                    id="currentPassword"
                    type="password"
                    name="currentPassword"
                    required
                    value={currentPassword || ""}
                    onChange={(e) => setCurrentPassword(e.target.value)} // You might need a new handler to update the recipients state
                    className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 focus:outline-none placeholder:text-gray-300 w-full"
                  />
                </div>
                <div className="flex flex-col mb-6">
                  <label htmlFor="newPassword" className="text-lg mb-2">
                    New Password
                  </label>
                  <input
                    id="newPassword"
                    type="password"
                    name="newPassword"
                    required
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 focus:outline-none placeholder:text-gray-300 w-full"
                  />
                </div>
                <div className="flex flex-col mb-6">
                  <label htmlFor="confirmNewPassword" className="text-lg mb-2">
                    Confirm New Password
                  </label>
                  <input
                    id="confirmNewPassword"
                    type="password"
                    name="confirmNewPassword"
                    required
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    className="bg-[#F1F1F1] border-b-2 py-2 border-gray-300 focus:outline-none placeholder:text-gray-300 w-full"
                  />
                </div>
                {loader ? (
                  <Spinner size={"50"} />
                ) : (
                  <button
                    type="submit"
                    className="bg-primary rounded-md py-3 text-white w-full hover:opacity-90 transition-opacity duration-300"
                  >
                    Confirm Change
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResetPassword;
